/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectQueryResult } from '../../models/get-project-query-result';

export interface ApiProjectGetProjectGet$Plain$Params {
  Id: string;
}

export function apiProjectGetProjectGet$Plain(http: HttpClient, rootUrl: string, params: ApiProjectGetProjectGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetProjectGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectQueryResult>;
    })
  );
}

apiProjectGetProjectGet$Plain.PATH = '/api/Project/GetProject';
